<template>
    <i :class="['iconfont', icon]" :style="css" @click="click"></i>
</template>
<script>
import Base from './base';
export default {
    mixins: [Base],
    props: ['icon', 'handler']
};
</script>

<style lang="scss">
.map-mask {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    &.show {
        display: block;
    }
}
</style>
